import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActivateESimImg from '../../../Assets/images/Activation/ESIM.svg';
import BackButton from '../../../Assets/images/commonImages/backButton.svg';
import Button from '../../../components/Button/Button';
import Footer from '../../../components/Footer/Footer';
import SimpleHeader from '../../../components/Header/simpleHeader';
import { GetCustomer } from '../../../store/Checkout/actions';
import { reachPlan, trackOrder } from '../../../store/TrackOrder/actions';
import './ActivateESim.scss';
import { returnName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
};

const ActivateESim = (props: initialProps) => {
    const { getCustomer } = useSelector((state: any) => state.checkout);
    const { ReachPlan, TrackOrder } = useSelector((state: any) => state.trackOrder);
    const [currentuser, setCurrentuser] = useState<any>(null);
    // const [primaryCustomer, setPrimaryCustomer] = useState<any>(null);
    const [planData, setPlanData] = useState<any>([]);
    const [trackOrderData, setTrackOrderData] = useState<any>([]);
    const [woNumber, setWoNumber] = useState<any>(null);
    const [isFraudAcc, setIsFraudAcc] = useState<boolean>(false);
    // const [lineNumber, setLineNumber] = useState<any>(null);

    const dispatch = useDispatch();

    useEffect(() => {
        window.scroll(0,0);
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        if(customerDetail?.category === 'FRAUD') {
            setIsFraudAcc(true);
        }
        let currentPlan: any = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);
        let secondaryUserDetails: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUserDetails = JSON.parse(secondaryUserDetails);
        let woNumberMap: any = localStorage.getItem('woNumberMap');
        woNumberMap = JSON.parse(woNumberMap);
        let lineNumber: any = localStorage.getItem('lineNumber');
        lineNumber = JSON.parse(lineNumber);
        // setLineNumber(lineNumber);
        if (secondaryUserDetails) {
            setCurrentuser(secondaryUserDetails);
            setWoNumber(woNumberMap && woNumberMap[secondaryUserDetails?.id]);
        } else {
            setCurrentuser(customerDetail);
            setWoNumber(woNumberMap && woNumberMap[customerDetail?.id]);
        }
        setPlanData(currentPlan);
        // setPrimaryCustomer(customerDetail);
        let email: string = customerDetail && customerDetail.emailId ? customerDetail.emailId : '';
        email &&
            dispatch(
                GetCustomer({
                    username: encodeURIComponent(email),
                }),
            );
    }, []);

    const initialRender = useRef(true);
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            if (getCustomer.status === 'SUCCESS') {
                if (
                    getCustomer.data &&
                    getCustomer.data.shipmentInfo &&
                    getCustomer.data.reachPlanId &&
                    Object.keys(getCustomer.data.shipmentInfo)[Object.keys(getCustomer.data.shipmentInfo).length - 1]
                ) {
                    // setUser(getCustomer.data);
                    // let trackId = user && user.shipmentInfo && Object.keys(user.shipmentInfo)[0];
                    let trackId = props.history?.location?.orderId;
                    dispatch(
                        trackOrder({
                            poll: true,
                            orderId: trackId
                                ? trackId
                                : Object.keys(getCustomer.data.shipmentInfo)[
                                      Object.keys(getCustomer.data.shipmentInfo).length - 1
                                  ],
                        }),
                    );
                    dispatch(
                        reachPlan({
                            plan: getCustomer.data.reachPlanId,
                        }),
                    );
                }
            }
        }
    }, [getCustomer]);

    useEffect(() => {
        if (ReachPlan && ReachPlan.status === 'SUCCESS' && ReachPlan.data) {
            let currentPlan = localStorage.getItem('currentPlan');
            if (!currentPlan) {
                localStorage.setItem('currentPlan', JSON.stringify(ReachPlan.data));
            }
            setPlanData(ReachPlan.data);
        }
    }, [ReachPlan]);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current) {
            initialRender1.current = false;
        } else {
            if (TrackOrder && TrackOrder.status === 'SUCCESS') {
                setTrackOrderData(TrackOrder.data);
            }
        }
    }, [TrackOrder]);

    function convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number);
        return ordinalWords[value];
    }
    let secondaryUserDetails: any = localStorage.getItem('secondaryCustomerDetail');
    secondaryUserDetails = JSON.parse(secondaryUserDetails);
    let customerDetail: any = localStorage.getItem('customerDetail');
    customerDetail = JSON.parse(customerDetail);

    let disableActivate: boolean = false;
    if(secondaryUserDetails && customerDetail?.status !== 2 && customerDetail?.status !== 3 || isFraudAcc) {
        disableActivate = true;
    }
    return (
        <div className="TrackOrderMain">
            <div className="backdropcolorTrackOrder isMappingCount"></div>
            <SimpleHeader history={props.history} user={currentuser} isHelp={true} />

            <div className="InnerMainDiv">
                {trackOrderData && trackOrderData.orderId ? (
                    <div className="MiddleCard">
                        <img
                            src={BackButton}
                            alt=""
                            className="backToHomeA"
                            onClick={() =>
                                props.history.push({
                                    pathname: '/post-activation-home',
                                })
                            }
                        />
                        <div className="title">
                            Activate{' '}
                            {currentuser?.firstName || currentuser?.lastName ? (
                                    currentuser?.firstName && !currentuser?.lastName ? (
                                        `${returnName(currentuser, "firstName")}'s eSIM`
                                    ) : (
                                        !currentuser?.firstName && currentuser?.lastName ? (
                                        `${returnName(currentuser, "lastName")}'s eSIM`
                                        ) : (
                                        `${returnName(currentuser, "firstName")} ${returnName(currentuser,"lastName")}'s eSIM`
                                        )
                                    )
                                    ) : (
                                    convertToOrdinal((currentuser?.peerAccountRef?.split('|')[2] - 1))?.toUpperCase() + ' LINE eSIM'
                                )}
                            {/* {(currentuser?.lastName || currentuser?.firstName) ? `${returnName(currentuser, 'lastName')}'s eSIM` : returnName(currentuser,"firstName")
                                ? `${returnName(currentuser,"firstName")}'s eSIM`
                                : convertToOrdinal(currentuser?.peerAccountRef?.split('|')[2] - 1).toUpperCase() + ' LINE eSIM'}{' '} */}
                        </div>
                        <div className="bottomLine"></div>
                        <div className="innerContainer">
                            <div className="image">
                                <img src={ActivateESimImg} alt="" width="203px" height="140px" />
                            </div>
                            <div className="planName">
                                {currentuser?.firstName || currentuser?.lastName ? (
                                    currentuser?.firstName && !currentuser?.lastName ? (
                                        `${returnName(currentuser, "firstName")}`
                                    ) : (
                                        !currentuser?.firstName && currentuser?.lastName ? (
                                        `${returnName(currentuser, "lastName")}`
                                        ) : (
                                        `${returnName(currentuser, "firstName")} ${returnName(currentuser,"lastName")}`
                                        )
                                    )
                                    ) : (
                                    convertToOrdinal((currentuser?.peerAccountRef?.split('|')[2] - 1))?.toUpperCase() + ' LINE'
                                )}
                                {/* {(currentuser?.lastName || currentuser?.firstName) ? `${currentuser?.lastName ? returnName(currentuser, 'lastName') : ''}` : `${currentuser?.firstName ? returnName(currentuser, 'firstName') : ''}`
                                    ? `${currentuser?.firstName ? returnName(currentuser, 'firstName') : ''}` + ' ' + `${currentuser?.lastName ? returnName(currentuser, 'lastName') : ''}`
                                    : convertToOrdinal(currentuser?.peerAccountRef?.split('|')[2] - 1).toUpperCase() + ' LINE'}{' '} */}
                                {' - '}
                                {planData && planData.name}
                            </div>
                            <div className="orderNo">
                                Order no. {woNumber ? woNumber : trackOrderData && trackOrderData.woNumber}
                            </div>

                            <div className="msg">
                                Congratulations! You’ve bypassed the waiting game for a SIM delivery.
                            </div>

                            <div className="activateContainer">
                                <div className="activateYoureSim">Activate your eSIM</div>
                                <div className="lets">Let's get your brand new eSIM activated, in real time!</div>
                                <Button primary={true}
                                    onClick={() => props.history.push({
                                        pathname: '/activation',
                                        state: {
                                            redirectOnClick: true,
                                        },
                                    })}
                                    disabled={disableActivate}
                                    >
                                    Activate now
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="MiddleCard">
                        <CircularProgress className="loaderCheck" />
                    </div>
                )}
            </div>
            <Footer isFixed={true} />
        </div>
    );
};

export default ActivateESim;
